import { SkeletonLoader } from './SkeletonLoader';

import { cn } from '@/utils/styles';
import type { StyleClasses } from '@/utils/types';

type SkeletonListStyleClasses = StyleClasses<'root' | 'item'>;

export type SkeletonListProps = {
  className?: string;
  classes?: SkeletonListStyleClasses;
  count?: number;
};

export const SkeletonList = ({ className, classes, count = 1 }: SkeletonListProps) => {
  return (
    <div className={cn('flex flex-col gap-1', className, classes?.root)}>
      {Array.from({ length: count }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <SkeletonLoader key={index} className={cn('h-9', classes?.item)} />
      ))}
    </div>
  );
};

SkeletonList.displayName = 'SkeletonList';
